// unique ID to distinguish sync requests from different devices (may be stored in local)
import { nanoid } from 'nanoid';

export const userDeviceId = (() => {
    const storedValue = sessionStorage.getItem('userDeviceId');
    if (storedValue !== null) {
        return storedValue;
    }
    const value = nanoid(6);
    sessionStorage.setItem('userDeviceId', value);
    return value;
})()
